import {register} from '../vendor/theme-scripts/theme-sections';
import gridSlider from '../features/grid-slider';

register('list-collections', gridSlider);
